import { render, staticRenderFns } from "./order-detail.vue?vue&type=template&id=ec25fd12&scoped=true"
import script from "./order-detail.vue?vue&type=script&lang=js"
export * from "./order-detail.vue?vue&type=script&lang=js"
import style0 from "./order-detail.vue?vue&type=style&index=0&id=ec25fd12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec25fd12",
  null
  
)

export default component.exports